import axios from "./config";

export default {
  contactUs: (params: { phone: string; message: string; name: string; email: string; city: string }) => axios.post("/contact-us", params),
};
